@import '../../../index';

:host {
  display: block;
}

.menu-entry {
  font-size: 2.125rem;
  line-height: 1;
  padding: 1.25rem;
  color: $brand-black;
  display: block;

  &:hover {
    text-decoration: none;
    color: $brand-black;
  }

  &__image {
    display: none;
    height: 1rem;
    margin: 0 0.5rem;
  }

  &__description {
    font-weight: 300;
  }

  @media (min-width: $bp-lg) {
    font-size: 1rem;
    margin: 0 0.5rem;
    padding: 0.5rem 0.5rem 1rem;

    &::before {
      display: inline-block;
      content: ' ';
      height: 0.625rem;
      width: 0.125rem;
      margin: 0.4rem 1rem 0;
      vertical-align: text-top;
      background-color: #000227;
      opacity: 0.09;
      border-radius: 0.06325rem;
    }

    &__image {
      display: inline;
      height: 1rem;
      margin: 0 0.5rem;
    }

    &__description {
      font-weight: normal;
      padding-bottom: 0.25rem;
      border-bottom: 0.0625rem solid $brand-purple;
    }
  }
}
